export default "__VITE_ASSET__18a98fe0__"